export const CalculateTotalFacture = (stayRows, paymentRows, setTotalFacture) => {
    const updatedStayRows = [...stayRows];
    const updatedPaymentRows = [...paymentRows];
    let totallogement = 0;
    let totalconsommation = 0;
    updatedStayRows.forEach(stay => {
        let index = 0;
        if (stay.totalLoge) {
            totallogement += parseFloat(stay.totalLoge) || 0;  
            index += 1;
        }
        
    });
    updatedPaymentRows.forEach(payment => {
        if (payment.totalConsom) {
            totalconsommation += parseFloat(payment.totalConsom) || 0;
        }
    });
    let  totalFacture = totallogement + totalconsommation;
    setTotalFacture(totalFacture);
};

